import { KatapultElement, html } from '../../mixins/katapult-element.js';
import { SharingLink } from '../sharing-link/sharing-link.js';
import '../sharing-link/model-sharing-link.js';

customElements.define(
  'shared-model-space-details',
  class extends KatapultElement {
    static get template() {
      return html`
        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/sharing_link_id" data="{{linkId}}"> </katapult-firebase-worker>
        <katapult-firebase-worker
          path="photoheight/company_space/[[userGroup]]/sharing_links/model_sharing/[[linkId]]"
          data="{{sharingLink}}"
        >
        </katapult-firebase-worker>

        <style>
          :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          model-sharing-link {
            width: 400px;
          }
        </style>

        <h1>Shared Model Details</h1>
        <template is="dom-if" if="[[sharingLink]]">
          <model-sharing-link
            link-id="[[linkId]]"
            sharing-link="[[sharingLink]]"
            company-id="[[userGroup]]"
            model-id="[[modelSpaceDetails.$key]]"
            model-label="[[modelSpaceDetails.label]]"
          ></model-sharing-link>
        </template>
      `;
    }

    static get properties() {
      return {
        linkId: String,
        modelSpaceDetails: Object
      };
    }
  }
);
